import React, { useState, Component  }  from 'react';
import { Button ,Modal,Spin,Form,Input} from 'antd';
import { useHistory } from 'react-router-dom';
import LinkButton from '../../components/link-button';
import {reqResetMail,reqResetCodeConfirm,reqResetPassword} from '../../api';
import CryptoJS from 'crypto-js';
import logo from '../../assets/image/logo.png'
import './reset.less';




const ResetForm = () => {
    const [form] = Form.useForm();
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [buttonText, setButtonText] = useState('メールを送信する');
    const [step, setStep] = useState(0);
    const [loading, setLoading] = useState(false);
    const [userMailAddress, setUserMailAddress] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const history = useHistory();


    const validatePassword = (_, value) => {
      if (!value) {
        return Promise.resolve();
      }else{
          const letterCount = (value.match(/[a-zA-Z]/g) || []).length;
          const numberCount = (value.match(/\d/g) || []).length;
          if (letterCount < 1 || numberCount < 1 || value.length < 6 || value.length > 15) {
            return Promise.reject(new Error("英文字と数字を含む、6-15桁文字で入力してください。"));
          }
          if (value && form.getFieldValue('password1') && value !== form.getFieldValue('password1')) {
            return Promise.reject(new Error('パスワードとパスワード再入力が一致しません。'));
          }
          return Promise.resolve();
      }
      
    };

    const onResetFinish = async (values) => {
      setLoading(true)
      // メール送信
      if  (step ===0){
        const { mailAddress} = values
        const result =  await reqResetMail(mailAddress)
        if (result.status===0) {
          setStep(step + 1)
          setUserMailAddress(mailAddress)
          setButtonText('コードを認証する')
          setButtonDisabled(true)
        }else{
          setErrorMsg(result.data)
        }
      }else if  (step ===1){
        const { code} = values
        const result =  await reqResetCodeConfirm(code,userMailAddress)
        if (result.status===0) { 
          setStep(step + 1)
          setButtonText('パスワードを変更する')
          setButtonDisabled(true)
        }else{
          setErrorMsg(result.data)
        }
      }else if  (step ===2){
        const { password1} = values
        const password = CryptoJS.SHA256(password1).toString();
        const result =  await reqResetPassword(userMailAddress,password)
        if (result.status===0) { 
          setStep(step + 1)
          setButtonDisabled(false)
          setButtonText('ログインページに戻る')          
        }else{
          setErrorMsg(result.data)
        }
      }else if  (step ===3){        
        loginClick()
      }
      setLoading(false)
      
  };

  
  const loginClick=()=>{
    history.push('/login');
}



  const formValuesChange = () => {
    setErrorMsg('')
    setTimeout(() => {
        const hasErrors = form.getFieldsError().some(({ errors }) => errors.length > 0);
        setButtonDisabled(hasErrors);
        
        

      }, 100);
  };
      const spinStyle = {
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.6)',
          zIndex: 1000,
          overflow: 'auto',
      };
      
    return (
            <>
      <Modal
        style={{
            top: 0,
            }}
          title={null}
          footer={null}
          visible={true}   
          maskClosable={false}
          closable={false}
          maskStyle={{ backgroundColor: 'white' }}
        >
        {loading && <div style={spinStyle}>
                        <Spin spinning={loading} size="large" />
                        </div>}
                        <Form
                        layout="vertical"
                        form={form}
                        onValuesChange={formValuesChange}
                        name="request"
                        className="login-form"
                        initialValues={{ remember: false }}
                        onFinish={onResetFinish}
                        >
                        {step === 0 && <Form.Item>
                            <div className="login-header" >
                                <img alt='' src={logo}></img>
                                <div className="title">パスワード再設定</div>
                            </div>
                        </Form.Item>}
                        {step === 0 && <Form.Item>
                          <div style={{fontSize:'14px'}}>パスワード再設定要のメールを送信します。登録されたメールアドレスを入力してください。</div>
                        </Form.Item>}

                      {step === 0 && <Form.Item 
                          label={<span className='login-form-title'>メールアドレス</span>}
                          name='mailAddress'
                          rules={[{ required:true, message:"入力は必須です。" },
                                  { type:'email', message:"有効なメールアドレスを入力してください。" }]}
                          initialValue="">
                          <Input className="login-form-item"/>
                      </Form.Item>}

                      {step === 1 && <Form.Item>
                            <div className="login-header" >
                                <div style={{fontSize:'20px',fontWeight:'bold'}}>メールが送信されました</div>
                            </div>
                        </Form.Item>}
                        {step === 1 && <Form.Item>
                          <div style={{fontSize:'14px'}}>{userMailAddress}に送信された認証コードを入力してください。</div>
                        </Form.Item>}

                      {step === 1 && <Form.Item 
                          label={<span className='login-form-title'>認証コード</span>}
                          name='code'
                          rules={[{ required:true, message:"入力は必須です。" },
                                  {pattern: /^\d{6}$/,message: '6桁の数字のみを入力してください',}]}
                          initialValue="">
                            <Input maxLength={6} placeholder="6桁の数字を入力"/>
                      </Form.Item>}


                      {step === 2 && <Form.Item>
                            <div className="login-header" >
                                <div style={{fontSize:'20px',fontWeight:'bold'}}>新しいパスワードを設定する</div>
                            </div>
                        </Form.Item>}

                      {step === 2 && <Form.Item
                            label={<span className='login-form-title'>新しいパスワード</span>}
                            name="password1"
                            rules={[{ required:true, message:"入力は必須です。" },
                                    { validator: validatePassword }]}
                            initialValue="">
                            <Input.Password className="login-form-item"/>
                        </Form.Item>}
                        {step === 2 && <Form.Item
                            label={<span className='login-form-title'>パスワード再入力</span>}
                            name="password2"
                            dependencies={['password1']}
                            rules={[{ required:true, message:"入力は必須です。" },
                                    { validator: validatePassword }]}
                            initialValue="">
                            <Input.Password className="login-form-item"/>
                        </Form.Item>}


                        {step === 3 && <Form.Item>
                            <div className="login-header" >
                                <div style={{fontSize:'20px',fontWeight:'bold'}}>パスワード変更が完了しました</div>
                            </div>
                        </Form.Item>}
                        
                        {step === 3 && <Form.Item>
                          <div style={{fontSize:'14px'}}>新しいパスワードで今すぐログインできます。</div>
                        </Form.Item>}


                        <Form.Item className="login-form-error">
                            <span >{errorMsg}</span>
                        </Form.Item>

                        {step !==3 && <Form.Item >
                            <Button type="primary" htmlType="submit" className="login-form-button" disabled={buttonDisabled}>
                            {buttonText}
                            </Button>
                        </Form.Item>}

                        
                        <Form.Item >
                            <LinkButton onClick={loginClick}>ログインページに戻る</LinkButton>
                        </Form.Item>
                        
                    </Form>
              </Modal>      
            </>
    );
  }

export default class Reset extends Component {
    render() {
      document.title = 'パスワード再設定'
      return (
            <ResetForm />        
      );
    }
  }
  



